<template>
  <div>
    <v-dialog v-model="hideShow" width="920" persistent scrollable content-class="wait-approve-dialog" aria-label="待核销课次">
      <v-card class="wa-shell">
        <v-card-title class="wa-header">
          <span class="wa-symbol"><v-icon size="26" color="#d9363e">mdi-calendar-check-outline</v-icon></span>
          <div class="wa-heading"><h2>待核销课次</h2><p>核对上课记录，完成学员课时核销</p></div>
          <span class="wa-count"><strong>{{data.total}}</strong><span>节待核销</span></span>
          <v-btn icon aria-label="关闭待核销课次" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="wa-body">
          <div class="wa-list-heading"><h3>课次列表</h3><span>选择课次，点击「核销」进入点名</span></div>
          <v-data-table class="wa-table" :headers="data.headers" :items="data.list" :loading="data.query.loading" fixed-header disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无待核销课次" :mobile-breakpoint="0">
            <template v-slot:item.classDate="{item}"><time class="wa-date">{{item.classDate}}</time></template>
            <template v-slot:item.classTime="{item}"><span class="wa-time"><v-icon size="15">mdi-clock-outline</v-icon>{{item.timeFrom}}<span class="wa-time-divider">–</span>{{item.timeTo}}</span></template>
            <template v-slot:item.className="{item}"><span class="wa-class">{{item.className}}</span></template>
            <template v-slot:item.teacherName="{item}"><span class="wa-teacher"><span class="wa-avatar">{{(item.teacherName || '师').slice(0,1)}}</span><span>{{item.teacherName || '—'}}</span></span></template>
            <template v-slot:item.action="{item}"><v-btn class="wa-approve" small depressed color="#d9363e" dark @click="showApprove(item)" :aria-label="'核销 '+item.classDate+' '+item.className">核销<v-icon size="16" right>mdi-chevron-right</v-icon></v-btn></template>
            <template v-slot:no-data><div class="wa-empty"><v-icon size="40" color="#a8b7c7">mdi-calendar-check-outline</v-icon><strong>暂无待核销课次</strong><span>当前范围内没有待核销的上课记录</span></div></template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="wa-footer">
          <div class="wa-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChanged" dense hide-details outlined v-model="data.query.size" color="#d9363e" aria-label="每页课次数量" /><span>条</span></div>
          <span class="wa-total">共 {{data.total}} 条</span>
          <v-spacer />
          <v-pagination v-if="Math.ceil(data.total/data.query.size)>0" class="wa-pagination" :length="Math.ceil(data.total/data.query.size)" @input="handlePageChanged" :total-visible="5" v-model="data.query.page" color="#d9363e" aria-label="待核销课次分页" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <approveRecord :show="approve.show" :recordId="approve.approveId" @cancel="approve.show=false" @success="approveSuccess" />
  </div>
</template>


<script>
	import utils from "../config/utils"
	import approveRecord from "./approve_record.vue"
	export default {
		name:"wait-approve-card",
		components:{approveRecord},
		props:{
			show:{
				type:Boolean,
				default:false
			}
		},
		watch:{
			show(newVal,oldVal){
				this.hideShow = newVal;
				if (this.hideShow){
					this.getDataList();
				}
			}
		},
		data(){
			return {
				hideShow:this.show,
				shopId:"",
				data: {
					total:0,
					query:{
						loading:false,
						page:1,
						size:10
					},
					headers:[
						{
							text: '上课日期',
							value: 'classDate',
							sortable: false
						},
						{
							text: '上课时间',
							value: 'classTime',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list:[],
					
				},
				approve:{
					show:false,
					approveId:""
				}
			}
		},
		mounted() {
			this.shopId = utils.getCurrentShopId();
			console.log("wait-approve-card mounted shopid",this.shopId);
		
		},
		methods:{
			handleSizeChanged(size) {
				this.data.query.size = size;
				this.data.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.data.query.page = page;
				this.getDataList();
			},
			showApprove(item){
				this.approve.approveId = item.id;
				this.approve.show = true;
			},
			approveSuccess(){
				this.getDataList();
				this.approve.show = false;
				
			},
			getDataList(){
				const that = this;
				let url = `/edu/teacher/wait/approve/record/list/page/${that.data.query.page - 1}/size/${that.data.query.size}?v=1`;
				if (this.shopId){
					url += "&shopId="+this.shopId;
				}
				
				console.log(url);
						
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			}
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/wait-approve.scss"></style>
